import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ 
    children, 
    requireAuth = true, 
    requireRole = null, 
    redirectTo = '/login' 
}) => {
    const location = useLocation();
    const { isAuthenticated, loading, user } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#bc965e'
            }}>
                Loading...
            </div>
        );
    }

    // If route requires authentication but user is not authenticated
    if (requireAuth && !isAuthenticated) {
        return <Navigate to={redirectTo} state={{ from: location.pathname }} replace />;
    }

    // If route requires specific role but user doesn't have it
    if (requireAuth && isAuthenticated && requireRole && user?.role !== requireRole) {
        // Redirect to appropriate dashboard based on user's actual role
        if (user?.role === 'Admin') {
            return <Navigate to="/admin/dashboard" replace />;
        } else {
            return <Navigate to="/" replace />;
        }
    }

    // For public routes (requireAuth = false), allow access regardless of authentication status
    // This allows logged-in users to access login, signup, etc. if they navigate there manually

    return children;
};

export default ProtectedRoute;